function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.1429 14.3333H25.4286C26.8482 14.3333 28 15.4531 28 16.8333V26.8333C28 28.2135 26.8482 29.3333 25.4286 29.3333H6.57143C6.25231 29.3333 5.94673 29.2767 5.66472 29.1733C6.21398 29.2051 6.72895 29.0423 7.09992 28.6713L24.1429 11.6284V14.3333ZM22.4597 5.76905C20.9698 3.884 18.6281 2.66666 16 2.66666C11.5107 2.66666 7.85714 6.21874 7.85714 10.5833V14.3333H6.57143C5.15179 14.3333 4 15.4531 4 16.8333V24.2288L13.8955 14.3333H12.1429V10.5833C12.1429 8.51562 13.8732 6.83332 16 6.83332C17.473 6.83332 18.7559 7.64031 19.4054 8.82342L22.4597 5.76905Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3559 6.52987C28.2405 5.64523 28.5355 4.50599 28.0148 3.98529C27.4941 3.46459 26.3549 3.75962 25.4703 4.64425L1.97767 28.1368C1.09304 29.0215 0.798013 30.1607 1.31871 30.6814C1.83941 31.2021 2.97866 30.9071 3.86329 30.0225L27.3559 6.52987Z"
});

var SvgUnlock = function SvgUnlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#D1D1D6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unlock.f5332086.svg";
export { ForwardRef as ReactComponent };